import { useContext, useMemo, useState } from "react";
import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import { SchoolClassSidebar } from "./SchoolClassSidebar";
import { SchoolClassDetail } from "./SchoolClassDetail";
import { buildDarkTheme } from "pages/SchoolShiftPage/_components/Constants";
import { GlobalDashboard } from "./GlobalDashboard";
import { useSchoolClass } from "../hooks/useSchoolClass";
import { FormProvider } from "react-hook-form";
import { DeleteClassModal } from "./tabs/ClassSettingsTab/DeleteClassModal";
import { AppContext } from "context/AppContextProvider";

export function SchoolClassPage() {
  const { state, actions, form } = useSchoolClass();
  const { theme: appThemeName } = useContext(AppContext);
  const darkTheme = useMemo(() => buildDarkTheme(appThemeName), [appThemeName]);

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Box 
        sx={{ 
          display: 'flex', 
          height: '100vh', 
          bgcolor: 'background.default',
          pt: { xs: 1, md: 2 }, 
          px: { xs: 1, md: 2 },
          pb: { xs: 1, md: 1 }, 
          gap: { xs: 1, md: 1 },
          overflow: 'hidden'
        }}
      >
        <SchoolClassSidebar state={state} actions={actions} />
        
        <FormProvider {...form}>
          <Box 
            component="main"
            sx={{ 
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              minWidth: 0,
              minHeight: 0,
              overflowY: 'auto', 
              borderRadius: 2, 
              bgcolor: 'background.default',
              scrollbarWidth: 'none', 
              '&::-webkit-scrollbar': { display: 'none' } 
            }}
          >
            {state.selectedId === 'all' ? (
              <GlobalDashboard state={state} />
            ) : (
              <SchoolClassDetail state={state} actions={actions} />
            )}
          </Box>
        </FormProvider>
      </Box>

      <DeleteClassModal
        open={state.deleteModalOpen}
        className={state.classToDelete?.name || ''}
        isDeleting={state.isDeleting}
        onClose={() => actions.setDeleteModalOpen(false)}
        onConfirm={actions.handleConfirmDelete}
      />
    </ThemeProvider>
  );
}

export default SchoolClassPage;